import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = 0;
  private isLoading = new BehaviorSubject<boolean>(false);

  isLoading$: Observable<boolean> = this.isLoading.asObservable();

  show(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      setTimeout(() => this.isLoading.next(false));
    }
  }

  hide(): void {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0; // Reset to 0 in case of any race conditions
      setTimeout(() => this.isLoading.next(false));
    }
  }
}
